var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.217,
    height: 12.217,
    viewBox: "0 0 12.217 12.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    d: "M8.022,5.644H5.245V2.867a.617.617,0,0,0-.617-.617H4.011a.617.617,0,0,0-.617.617V5.644H.617A.617.617,0,0,0,0,6.261v.617a.617.617,0,0,0,.617.617H3.394v2.777a.617.617,0,0,0,.617.617h.617a.617.617,0,0,0,.617-.617V7.495H8.022a.617.617,0,0,0,.617-.617V6.261A.617.617,0,0,0,8.022,5.644Z",
    transform: "translate(-1.591 4.517) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.b9b1733b42c0ea2bcf5a250091bf1df5.svg";
export { ForwardRef as ReactComponent };